/**
 * FillBar — horizontal sold/cap bar. Port of `NBFillBar`.
 *
 * Tone derives from the fill ratio: <50% → warn, ≥100% → full,
 * otherwise the persona primary color.
 */
export interface FillBarProps {
  sold: number;
  cap: number;
  /** A number is pixels; a string is any CSS length — `'100%'` to fill a row. */
  width?: number | string;
  ariaLabel?: string;
}

export function FillBar({ sold, cap, width = 80, ariaLabel }: FillBarProps) {
  const safeCap = Math.max(1, cap);
  const pct = Math.min(100, Math.round((sold / safeCap) * 100));
  const tone = pct >= 100 ? 'full' : pct < 50 ? 'warn' : '';
  return (
    <div
      className={`nb-bar ${tone}`}
      style={{ width }}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={cap}
      aria-valuenow={sold}
      aria-label={ariaLabel ?? `${sold} of ${cap}`}
    >
      <i style={{ width: `${pct}%` }} />
    </div>
  );
}
